import React, { ChangeEvent, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import money from "../../../../assets/Images/1635d86b32b60583e7f022b9c3324b3d.png";
import payimg from "../../../../assets/Images/pay.png";
import Dones from "../../../../assets/Images/success-image.png";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import CommonButtons from "../../../../shared/components/CommonButtons";
import OrderProductsList from "./order-display/components/OrderProductsList";
import OrderCustomerInfo from "./order-display/components/OrderCustomerInfo";
import OrderPriceDetails from "./order-display/components/OrderPriceDetails";
import OrderPaymentMethods from "./order-display/components/OrderPaymentMethods";
import PaymentSummaryModal from "./order-display/modals/PaymentSummaryModal";
import CashPaymentSummaryModal from "./order-display/modals/CashPaymentSummaryModal";
import PaymentConfirmModal from "./order-display/modals/PaymentConfirmModal";
import CancelOrderDialog from "./order-display/modals/CancelOrderDialog";
import { getOrdersApi } from "./order-display/api";
import { useOrderDisplay } from "../../../../shared/hooks/useOrderDisplay";
import { date, orderback, formatNumber, formatNumbers, COMPLETE, OrderUpdate } from "./order-display/orderHelpers";
import { cancelOrder, handleChange } from "./order-display/services/orderServices";
import LoadingScreen from "src/shared/components/LoadingScreen";
import { useCustomer } from "src/business-types/laundry/modules/home/Done/hooks/useCustomer";
import { useUser } from "src/shared/context/UserContext";
import { Order } from "src/shared/services/interfacev2";
import { splitDateTime } from "src/shared/components/dateTime";
import { useUserTheme } from "src/shared/hooks/useUserTheme";
import { patchOrder } from "src/shared/services/services";
import { processCardPayment } from "src/paymentGatway/useCardPayment";

declare global {
  interface Window {
    Razorpay: any;
  }
}

const OrderDisplay: React.FC = () => {
  const [getorder, setGetOrder] = useState<Order>();
  const [bproducts, setbuttonname] = useState<Order>();
  const [move, setmove] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [showPaymentMethods, setShowPaymentMethods] = useState<string>("");
  const [outstangingamount, setoutstangingamount] = useState<number>(0);
  const [, setemployeesData] = useState(false);
  const [logo, setlogo] = useState<any>();
  const [time, setTime] = useState({ hours: "", minutes: "", seconds: "", day: "", month: "", year: "" });
  const navigate = useNavigate();
  const { orderid } = useParams();
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [cancelData, setCancelData] = useState<string>("refund");
  const { user, userConfigration } = useUser();
  const customerId = getorder?.orders[0]?.customerId || bproducts?.orders[0]?.customerId;
  const { customerData, clientId: filteredCustomerId } = useCustomer(customerId);
  const { sidebarThemeClass } = useUserTheme();

  const { printData, Remainingpayments, Receivedbalance, remaining, AdvanceAmount, discountValue, ledgerDiscount, roundValue, cashoutstanging, Outamount, refundAmount, handleclick, handleBlur, 
    outstandingvalue, payments, inputValue, condition, model, glowery, confirm, setmodel, setglowery, setConfirm, setPrintHistory, setpaylate, setcashpay, setpaycard, paylate, cashpay, paycard
     } = useOrderDisplay({ bproducts, orderid: orderid || "", logo, outstangingamount: Number(outstangingamount ?? 0), getorder });

  useEffect(() => {
    date(setTime);
    getOrdersIn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const employee = () => {
      const employeeData = sessionStorage.getItem("employee");
      if (employeeData) {
        setemployeesData(true);
      } else {
        setemployeesData(false);
      }
    };
    employee();
    const logo = user?.profileImageUrl || "";
    setlogo(logo);
  }, [user?.profileImageUrl]);

  const droupdown = () => {
    const handleDelivered = () => {
      toast.success("Order has been delivered successfully!", {
        style: { borderRadius: "12px", background: "#1e293b", color: "#fff" },
      });
    };

    type StatusType = "Confirm" | "In-process" | "Waiting for delivery" | "Delivered" | "Cancelled" | "deleted";

    const currentMove = (move as StatusType) || "Confirm";

    const availableOptions: Record<StatusType, StatusType[]> = {
      Confirm: ["Confirm", "In-process", "Waiting for delivery"],
      "In-process": ["In-process", "Waiting for delivery", "Delivered"],
      "Waiting for delivery": ["Waiting for delivery", "Delivered"],
      Delivered: ["Delivered"],
      Cancelled: ["Cancelled"],
      deleted: ["deleted"],
    };

    return (
      <div className="w-full pt-1 pb-1 animate-in fade-in slide-in-from-top-4 duration-500">
        <div className="flex items-center gap-2 px-1">
          <div className="h-4 w-1 bg-slate-900 rounded-full" />
          <h3 className="text-[11px] font-black uppercase tracking-[0.15em] text-slate-500">Order status</h3>
        </div>

        <div className="relative group">
          <select
            value={currentMove}
            onChange={(e) => {
              const val = e.target.value as StatusType;
              if (val === "Delivered") handleDelivered();
              handleChangeEvent(e);
            }}
            disabled={currentMove === "Delivered" || currentMove === "Cancelled" || currentMove === "deleted"}
            className="w-full bg-white border border-slate-200 rounded-2xl px-4 py-3.5 text-sm font-semibold text-slate-700 outline-none ring-offset-2 focus:ring-2 focus:ring-slate-900/5 focus:border-slate-900 transition-all appearance-none cursor-pointer disabled:bg-slate-50 disabled:cursor-not-allowed"
          >
            {availableOptions[currentMove]?.map((opt) => (
              <option key={opt} value={opt} className="text-slate-700 font-medium">
                {opt}
              </option>
            ))}
          </select>

          <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none text-slate-400 group-hover:text-slate-600 transition-colors">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>

        {(currentMove === "Delivered" || currentMove === "Cancelled") && (
          <p className="mt-3 text-center text-[10px] text-slate-400 font-medium italic">This order is finalized and cannot be modified.</p>
        )}
      </div>
    );
  };

  // ✅ OPTIMIZED - Only fetch order data
  const getOrdersIn = async (options = { showLoading: true }) => {
    const { showLoading = true } = options;

    if (showLoading) {
      setLoading(true);
    }

    try {
      const res = await getOrdersApi(orderid!);
      const buttonData: Order = res.data.result;

      // Set order data
      setbuttonname(buttonData);
      // ✅ Removed ordersucess state - using getorder directly
      setGetOrder(buttonData);
      setmove(buttonData?.orders[0].status || "");

      // Get outstanding from totalOutstandingBalance
      const outstanding = buttonData?.totalOutstandingBalance || 0;
      setoutstangingamount(outstanding);

      // Update showPaymentMethods based on order status
      if (buttonData?.orders[0].status.includes("Waiting for delivery")) {
        setShowPaymentMethods("true");
      } else if (buttonData?.orders[0].status === "Delivered") {
        setShowPaymentMethods("");
      }
    } catch (err) {
      console.error(err);
    } finally {
      if (showLoading) {
        setLoading(false);
      }
    }
  };

  const handleCancel = async () => {
    try {
      const paymentMethod = getorder?.paymentHistory?.[0]?.paymentMethod;

      await cancelOrder(orderid, cancelData, paymentMethod, setmove);

      await getOrdersIn({
        showLoading: true,
      });

      setOpenCancelDialog(false);
    } catch (err) {
      console.error("Error in handleCancel:", err);
    }
  };

  const handleChangeEvent = (event: ChangeEvent<HTMLSelectElement>) => {
    handleChange(orderid, event, setmove, () =>
      getOrdersIn({
        showLoading: false,
      }),
    );
  };

  const handleConfirm = async (Payment: string) => {
    const update = OrderUpdate({
      getorder,
      condition,
      inputValue: Number(inputValue),
      outstangingamount: Number(outstangingamount),
      time,
      Payment,
    });

    if (update.payments.paymentMethod === "Card" && update.payments.receivedAmount > 0 && Boolean(userConfigration?.cardPayment) === true) {
      await processCardPayment({
        amount: update.payments.receivedAmount,
        description: `Ledger payment for ${customerId}`,
        onSuccess: async (paymentDetails) => {
          const paysucess = {
            ...update,
            paymentDetails,
          };

          try {
            await patchOrder(String(orderid), paysucess);
            setmodel(false);
            setglowery(false);
            setConfirm(true);
            setPrintHistory(true);
            getOrdersIn();
          } catch (err) {
            console.error(err);
          }
        },
      });
      return;
    }

    patchOrder(String(orderid), update)
      .then(() => {
        setmodel(false);
        setglowery(false);
        setConfirm(true);
        setPrintHistory(true);
        getOrdersIn();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const remainingBalance = Number(Outamount()) - condition;
  const formattedBalance = remainingBalance.toFixed(2);
  const totaloutstandingboc = Number(cashoutstanging) + Number(getorder?.orders[0].remainingAmount);

  const { date: orderDate, time: orderTime } = splitDateTime(getorder?.orderDetails[0].orderedOn.$date ?? "");
  const toBoolean = (value: any) => value === true || value === "true";

  const deliveryFeeEnabled = toBoolean(userConfigration?.deliveryFeeEnabled);

  return (
    <div className="flex flex-col overflow-hidden w-full">
      <div className="w-full h-full overflow-hidden ">
        <div className="thin-scrollbar w-full flex-1 flex flex-col lg:flex-row gap-2 p-1 h-full overflow-auto">
          <div className={`lg:w-4/6 w-full p-2 h-full flex flex-col overflow-x-auto shadow-inner rounded-lg ${sidebarThemeClass}`}>
            <div className="mb-1.5">
              <CommonButtons className="shadow-sm border border-gray-300" label="BACK" onClick={() => navigate(-1)} variant="secondary" icon={KeyboardReturnIcon} />
            </div>
            <div className="flex-1 min-h-0 overflow-hidden">
              <OrderProductsList products={getorder?.orderDetails.flatMap((detail) => detail.products || []) || []} />
            </div>
          </div>
          <div className={`thin-scrollbar xl:w-4/12 lg:w-5/12 w-full h-full pr-1 flex flex-col flex-shrink-0 lg:overflow-y-auto lg:overflow-x-hidden shadow-inner rounded-lg p-1 ${sidebarThemeClass}`}>
            <OrderCustomerInfo
              orderId={String(getorder?.orders[0].orderId ?? "-")}
              customerName={`${getorder?.customerDetails.firstName ?? ""} ${getorder?.customerDetails.middleName ?? ""} ${getorder?.customerDetails.lastName ?? ""}`.trim() || "-"}
              order={getorder}
            />
            <OrderPriceDetails
              roundValue={roundValue}
              totalAmount={getorder?.orders[0].orderAmount ?? 0}
              discount={discountValue ?? 0}
              deliveryFee={getorder?.orders[0].deliveryFee ?? 0}
              deliveryFeeEnabled={deliveryFeeEnabled}
              finalAmount={getorder?.orders[0].finalAmount ?? 0}
              receivedBalance={Receivedbalance ?? 0}
              remaining={remaining() ?? 0}
              AdvanceAmount={AdvanceAmount ?? 0}
              outstandingAmount={Number(outstangingamount ?? 0)}
              ledgerDiscount={ledgerDiscount}
              paymentMethod={getorder?.paymentHistory?.at(-1)?.paymentMethod ?? "-"}
              orderDate={orderDate}
              orderTime={orderTime}
            />
            <OrderPaymentMethods
              droupdown={droupdown}
              showPaymentMethods={Boolean(showPaymentMethods)}
              remaining={remaining}
              outstangingamount={() => Number(outstangingamount ?? 0)}
              payments={payments}
              getorder={getorder}
              setOpenCancelDialog={setOpenCancelDialog}
              filteredCustomerId={filteredCustomerId}
              printData={printData}
              COMPLETE={COMPLETE}
              paylate={paylate}
              cashpay={cashpay}
              setpaylate={setpaylate}
              setcashpay={setcashpay}
              paycard={paycard}
              setpaycard={setpaycard}
            />
            <CancelOrderDialog
              open={openCancelDialog}
              setOpenCancelDialog={setOpenCancelDialog}
              Remainingpayments={Number(Remainingpayments ?? 0)}
              cancelData={cancelData}
              setCancelData={setCancelData}
              roundValue={roundValue}
              Receivedbalance={() => Number(Receivedbalance ?? 0)}
              outstangingamount={Number(outstangingamount)}
              getorder={getorder}
              refundAmount={refundAmount}
              cancelOrder={handleCancel}
            />
          </div>
        </div>
        <ToastContainer />
      </div>
      <PaymentSummaryModal
        model={model}
        setmodel={setmodel}
        orderback={() => orderid && orderback(orderid)}
        getorder={getorder}
        roundValue={roundValue}
        cashoutstanging={cashoutstanging}
        totaloutstandingboc={totaloutstandingboc}
        handleConfirm={handleConfirm}
        payimg={payimg}
        money={money}
        deliveryFeeEnabled={deliveryFeeEnabled}
      />
      <CashPaymentSummaryModal
        glowery={glowery}
        setglowery={setglowery}
        orderback={() => orderid && orderback(orderid)}
        getorder={getorder}
        roundValue={roundValue}
        cashoutstanging={cashoutstanging}
        totaloutstandingboc={totaloutstandingboc}
        handleConfirm={handleConfirm}
        payimg={payimg}
        money={money}
        inputValue={inputValue}
        handleclick={handleclick}
        handleBlur={handleBlur}
        Outamount={Outamount}
        formatNumber={formatNumber}
        formatNumbers={formatNumbers}
        formattedBalance={formattedBalance}
        outstandingvalue={outstandingvalue}
        deliveryFeeEnabled={deliveryFeeEnabled}
        paymenytMethod={paycard ? "Card" : "Cash"}
      />
      <PaymentConfirmModal
        getorder={getorder || undefined}
        confirm={confirm}
        setConfirm={setConfirm}
        Customer={customerData || undefined}
        printData={printData}
        filteredCustomerId={filteredCustomerId}
        Dones={Dones}
        loading={loading}
        onOrderComplete={() =>
          getOrdersIn({
            showLoading: true,
          })
        }
      />
      {loading && <LoadingScreen />}
    </div>
  );
};

export default OrderDisplay;